import { render, staticRenderFns } from "./LoadingSection.vue?vue&type=template&id=35a21af4&scoped=true&"
var script = {}
import style0 from "./LoadingSection.vue?vue&type=style&index=0&id=35a21af4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a21af4",
  null
  
)

export default component.exports